import { defineComponent, createElementBlock, openBlock, normalizeClass, Fragment, renderList, createVNode } from 'vue';
import _sfc_main$1 from './basler-components.es131.js';
/* empty css                        */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TagList",
  props: {
    tags: {},
    isSmall: { type: Boolean, default: false },
    size: {},
    alignment: { default: "left" },
    styleType: { default: "primary" },
    isNotWrapped: { type: Boolean }
  },
  emits: ["click", "close"],
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: normalizeClass([
          "tag-list",
          `${_ctx.isSmall || _ctx.size === "small" ? "tag-list--is-size-small" : `tag-list--is-size-${_ctx.size || "large"}`}`,
          `tag-list--is-${_ctx.alignment}`,
          `tag-list--is-${_ctx.styleType}`,
          { "tag-list--is-not-wrapped": _ctx.isNotWrapped }
        ])
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(props.tags, (tag) => {
          return openBlock(), createElementBlock("li", {
            class: "tag-list__item",
            key: `${tag.text}${tag.link}`
          }, [
            createVNode(_sfc_main$1, {
              element: tag.element ? tag.element : "span",
              tag,
              "is-small": _ctx.isSmall,
              onClick: ($event) => _ctx.$emit("click", tag),
              onClose: ($event) => _ctx.$emit("close", tag)
            }, null, 8, ["element", "tag", "is-small", "onClick", "onClose"])
          ]);
        }), 128))
      ], 2);
    };
  }
});

export { _sfc_main as default };
